export default "__VITE_ASSET__GhyC02UU__"